import { Component, Inject, Output, OutputArgs, Input, Attribute } from "@fiqas/angular-utils";
import { FIQAssist } from "../../app";
import { Application } from "../application";
import { UserService } from "../../services/fiqassistApi/userService";
import { Person, CompactPerson, GetPersonsResult } from "../../models/person";
import { WebLink } from "../../models/base";

@Component({
    module: FIQAssist,
    selector: PersonTypeAhead.selector,
    template: `<div class="person-type-ahead-container ng-class:{'has-value': $ctrl.hasValue}">
                    <input type="text"
                        ng-model="$ctrl.selectedPerson"
                        placeholder=""
                        uib-typeahead="person as person.name for person in $ctrl.searchPerson($viewValue)"
                        typeahead-loading="loadingLocations"
                        typeahead-append-to-body="true"
                        typeahead-editable="false"
                        class="form-control">
                    <div ng-click="$ctrl.ClearField()" class="clearfield-icon">
                        <span class="icon-clearField"></span>
                    </div>
                </div>`,
    require: {
        application: "^application"
    }
})
export class PersonTypeAhead {
    public static selector = "personTypeAhead";
    private application: Application;
    private persons: Promise<GetPersonsResult>
    private initalized: boolean;

    constructor(
        @Inject() private userService: UserService
    ) {
    }

    async $onInit() {
        this.initalized = true;
        this.persons = this.userService.getPersons(this.application.selectedCustomers.map(c => c.key));
        this.application.addOnAccountsChanged((selector: { key: any, text: string }[]) => this.onadministrationchange(selector));
        await this.persons;
        if (this.initialId) {
            this.selectedId = this.initialId;
            this.initialId = null;
        }
        if (this.initialRef) {
            this.selectedRef = this.initialRef;
            this.initialRef = null;
        }
    }

    private _filterFormer: boolean;
    @Attribute() public set filterFormer(value: boolean | string) {
        this._filterFormer = value === true || value === "true";
    }
    public get filterFormer() {
        return this._filterFormer;
    }

    public onadministrationchange(selector: { key: any, text: string }[]) {
        this.persons = this.userService.getPersons(selector.map(x => x.key));
        this.ClearField()
    }

    private ClearField() {
        let val = this._selectedPerson;
        this._selectedPerson = null;
        if (val)
            this.onPersonChanged({ person: null });
    }

    private get hasValue() {
        return !!this._selectedPerson;
    }

    @Input()
    public hideFiqasEmployees: boolean;


    private initialId: WebLink;
    @Input()
    public set selectedId(id: WebLink) {
        if (id) {
            if (!this.initalized)
                this.initialId = id;
            else
                this.persons.then(ps => this._selectedPerson = ps.items.filter(p => p.id.equals(id)).shift());
        } else {
            this._selectedPerson = null;
        }
    }
    public get selectedId() {
        return this._selectedPerson ? this._selectedPerson.id : null;
    }

    private initialRef: string;
    @Input()
    public set selectedRef(ref: string) {
        if (ref) {
            if (!this.initalized)
                this.initialRef = ref;
            else
                this.persons.then(ps => this._selectedPerson = ps.items.filter(p => p.id.ref == ref).shift());
        } else {
            this._selectedPerson = null;
        }
    }
    public get selectedRef() {
        return this._selectedPerson ? this._selectedPerson.id.ref : null;
    }


    public async searchPerson(search: string) {
        let persons = await this.persons;
        return persons.items
            .filter(p => p.hasLogin && (!this.hideFiqasEmployees || !p.isFiqasEmployee) && (!this._filterFormer || !p.isFormerEmployee))
            .filter(p => p.name.toLowerCase().indexOf(search.toLowerCase()) > -1)
            .sort((pa, pb) => {
                let sd = pa.name.toLowerCase().indexOf(search.toLowerCase()) - pb.name.toLowerCase().indexOf(search.toLowerCase());
                if (sd === 0)
                    return pa.name === pb.name ? 0 : pa.name < pb.name ? -1 : 1;
                return sd;

            })
            .slice(0, 10);
    }

    private _selectedPerson: CompactPerson;
    @Input()
    private get selectedPerson() {
        return this._selectedPerson;
    }
    private set selectedPerson(person: CompactPerson) {
        let val = this._selectedPerson;
        this._selectedPerson = person;
        if (val != this._selectedPerson && (val && val.id || this._selectedPerson && this._selectedPerson.id)) {
            this.onPersonChanged({ person: this._selectedPerson });
        }
    }

    @Output() public onPersonChanged: OutputArgs<{ person: CompactPerson }>;
}
